// @flow
import { execute }        from 'fg-frontend/src/partialUpdate/partialUpdate';
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';

// import closeEsp         from 'fg-frontend/webActions/closeEsp';
// import goBack           from 'fg-frontend/webActions/goBack';
import scrollToHref     from 'fg-frontend/webActions/scrollToHref';
// import confirmPopup     from 'fg-frontend/webActions/confirmPopup';
// import passwordStrength from 'fg-frontend/webActions/passwordStrength';
// import toggleClass from 'fg-frontend/webActions/toggleClass';
import replaceHistory from 'fg-frontend/webActions/replaceHistory';
import executeAndClose from 'fg-frontend/webActions/executeAndClose';
// import targetClick from 'fg-frontend/webActions/targetClick';
// import printPage from 'fg-frontend/webActions/printPage';

export default (action) => {
  switch (action) {
  case 'execute':
    return execute;
  case 'executeAndClose':
    return executeAndClose;
  case 'replaceHistory':
    return replaceHistory;
  case 'scrollToHref':
    return scrollToHref;
  default:
    console.log('Unknown action');
    return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js